<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			Our Services
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
				<span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
				<span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
				<span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
				<span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
			</h5>
		  </div>
		</div>
	   </div>
	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice.jpg" alt="">
        <p>
            "We offer comprehensive servicing for all brands of screw air compressors, 
			ensuring optimal performance. Our skilled technicians provide maintenance, troubleshooting, 
			and repair services. We use genuine parts to ensure longevity and efficiency.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice1.jpeg" alt="">
        <p>
			"Our piston compressor service covers all major brands, including repair and preventive maintenance.
			 We address issues such as pressure loss, 
			air leaks, and compressor malfunction. Reliable and timely service to keep your equipment running smoothly.."
			
			
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice2.jpeg" alt="">
        <p>
			"We provide multi-brand air dryer services to maintain your compressed air quality.
			 Our experts perform thorough checks, cleaning,
			 and repairs to enhance performance. We ensure efficient energy use and prolonged dryer lifespan.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice3.jpg" alt="">
        <p>
			"We specialize in multi-brand water chiller services, including repair, maintenance, and installation. 
			Our team ensures your system operates with 
			maximum efficiency and minimal downtime. We handle all common issues and offer solutions for better cooling performance.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice4.jpg" alt="">
        <p>
			"Our oil chiller service covers all leading brands, focusing on maintenance and repair. 
			We ensure your oil cooling systems are running at peak performance with no
			 leaks or over-heating issues. We use high-quality parts to extend the life of your equipment.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice5.jpg" alt="">
        <p>
			"We offer professional air pipeline installation, maintenance, and modification services.
			 Our solutions ensure a steady, efficient flow of compressed air, reducing energy loss and 
			pressure drop. We handle both small and large-scale installations with precision.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice6.jpg" alt="">
        <p>
			"We provide expert panel air cooler services, including cleaning, maintenance, and repairs.
			 Our team ensures that your cooling systems operate efficiently, preventing 
			overheating and failures. We offer quick solutions to minimize operational disruptions.."
        </p>
    </div>
	  
	<!-- <div class="container p-4">
		<h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">
			verticals
		  </h4>
		<div class="row animatable fadeInUp">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-medkit service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Hospital Management System
						</h6>
						<p class="text-muted">
							Health Care.
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-dashboard service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Temple Management System
						</h6>
						<p class="text-muted">
							Religious. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-hotel service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Hotel Management System
						</h6>
						<p class="text-muted">
							Restaurants. 
						</p><br />
					</div>
				</div>
			</div> 
		</div><br />
		<div class="row  animatable fadeInUp">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-university service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							School Management System
						</h6>
						<p class="text-muted">
							Education. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-university service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							college Management System
						</h6>
						<p class="text-muted">
							Education. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-users service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Value Added Services
						</h6>
						<p class="text-muted">
							Bio metric Solutions.
							Bio metric Solutions.
						</p><br />
					</div>
				</div>
			</div> 
		</div><br />
		<div class="row  animatable fadeInUp">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center icon-border">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							Chits Management.
							Jewellery Management.
							Bakery Management 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							Pawn Broking.
							Whole Sale Management.
							Textile Management.
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							Furniture Management.
							Super market Management. 
						</p><br />
					</div>
				</div>
			</div>
		</div>
	</div> -->
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">

	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice1.jpeg" alt="">
        <p>
			"Our piston compressor service covers all major brands, including repair and preventive maintenance.
			 We address issues such as pressure loss, 
			air leaks, and compressor malfunction. Reliable and timely service to keep your equipment running smoothly.."
			
			
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice2.jpeg" alt="">
        <p>
			"We provide multi-brand air dryer services to maintain your compressed air quality.
			 Our experts perform thorough checks, cleaning,
			 and repairs to enhance performance. We ensure efficient energy use and prolonged dryer lifespan.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice3.jpg" alt="">
        <p>
			"We specialize in multi-brand water chiller services, including repair, maintenance, and installation. 
			Our team ensures your system operates with 
			maximum efficiency and minimal downtime. We handle all common issues and offer solutions for better cooling performance.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice4.jpg" alt="">
        <p>
			"Our oil chiller service covers all leading brands, focusing on maintenance and repair. 
			We ensure your oil cooling systems are running at peak performance with no
			 leaks or over-heating issues. We use high-quality parts to extend the life of your equipment.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice5.jpg" alt="">
        <p>
			"We offer professional air pipeline installation, maintenance, and modification services.
			 Our solutions ensure a steady, efficient flow of compressed air, reducing energy loss and 
			pressure drop. We handle both small and large-scale installations with precision.."
        </p>
    </div>
	<div class="content-container">
        <img src="../../assets/img/active-service/hdservice6.jpg" alt="">
        <p>
			"We provide expert panel air cooler services, including cleaning, maintenance, and repairs.
			 Our team ensures that your cooling systems operate efficiently, preventing 
			overheating and failures. We offer quick solutions to minimize operational disruptions.."
        </p>
    </div>
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<!-- <div class="container p-4">
		<h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">
			verticals
		  </h4>
		<div class="row">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-medkit service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Hospital Management System
						</h6>
						<p class="text-muted">
							Health Care.
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-dashboard service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Temple Management System
						</h6>
						<p class="text-muted">
							Religious. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-hotel service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Hotel Management System
						</h6>
						<p class="text-muted">
							Restaurants. 
						</p><br />
					</div>
				</div>
			</div> 
		</div><br />
		<div class="row">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-university service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							School Management System
						</h6>
						<p class="text-muted">
							Education. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-university service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							college Management System
						</h6>
						<p class="text-muted">
							Education. 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-users service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Value Added Services
						</h6>
						<p class="text-muted">
							Bio metric Solutions.
							Bio metric Solutions.
						</p><br />
					</div>
				</div>
			</div> 
		</div><br />
		<div class="row">
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center icon-border">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
						Pawn
						</h6>
						<p class="text-muted">
							Chits Management.
							Jewellery Management.
							Bakery Management 
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							<!-- Pawn Broking. 
							Whole Sale Management.
							Textile Management.
						</p><br />
					</div>
				</div>
			</div> 
			<div class="col-md-4 col-sm-12 col-xs-12">
				<div class="card service-card border-0 p-4">
					<div class="text-center">
						<span class="fa fa-shopping-cart service-icon" aria-hidden="true"></span>
						
						<h6 class="text-center text-dark text-uppercase font-weight-bolder pb-1">
							Retail
						</h6>
						<p class="text-muted">
							Furniture Management.
							Super market Management. 
						</p><br />
					</div>
				</div>
			</div>
		</div>
	</div> -->
</div>
